import { DeceasedProfile } from './../models/DeceasedProfile';
import { BasicAuthenticationService } from './../auth/basic-authentication.service';
import { Deceased } from './../models/deceased';
import { DeceasedDataService } from './../service/data/deceased-data.service';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-deceased-profile',
  templateUrl: './deceased-profile.component.html',
  styleUrls: ['./deceased-profile.component.css']
})
export class DeceasedProfileComponent implements OnInit {

  maleString = "M";
  femaleString = "F";

  deceaseds: DeceasedProfile[];

  deceasedProfileImages: DeceasedProfileImage[];

  constructor(public _DomSanitizationService: DomSanitizer, private deceasedDataService: DeceasedDataService, private basicAuthenticationService: BasicAuthenticationService) { }


  ngOnInit() {

    this.deceasedProfileImages = [];

    this.deceasedDataService.getDeceaseProfileByMainAccountId(this.basicAuthenticationService.getMainAccountId()).subscribe(
      response => {

        var firstKey = Object.keys(response)[0];

        if (firstKey.toUpperCase() == "OK") {
          this.deceaseds = response[firstKey];



          this.deceaseds.forEach(deceased => {


            this.deceasedDataService.getDeceasedProfileImageByDeceasedId(deceased.deceasedId).subscribe(

              response => {

                if(response.OK != null && response.OK !=''){
                  this.deceasedProfileImages.push( {"deceasedProfile": deceased, "image": response.OK } );
                }
                else
                {
                  if(deceased.gender.toUpperCase()==this.maleString)
                    this.deceasedProfileImages.push( {"deceasedProfile": deceased, "image": "./assets/images/person1.png"} );
                  else
                    if(deceased.gender.toUpperCase()==this.femaleString)
                      this.deceasedProfileImages.push( {"deceasedProfile": deceased, "image": "./assets/images/person3.png"} );
                }

              },
              error => {

              }

            );


          });
        }
        else
          if (firstKey.toUpperCase() == "ERROR") {

          }
      }
    )
  }

}


export interface DeceasedProfileImage {
  deceasedProfile :DeceasedProfile
  image: string
}
